import { Badge, Box } from '@mui/material';
import { ReactElement } from 'react';
import { useGetList, useGetResourceLabel } from 'react-admin';

export default function TrackedErrorsMenuLabel(): ReactElement {
  const getResourceLabel = useGetResourceLabel();
  const { total, isLoading, isPending } = useGetList('tracked_error_issues', {
    filter: { equals: { is_resolved: 'false' } },
    pagination: { page: 1, perPage: 1 },
    sort: { field: 'attributes.last_occurred_at_utc', order: 'DESC' },
  });

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        minWidth: 0,
        width: '100%',
      }}
    >
      {getResourceLabel('tracked_error_issues', 2)}
      <Badge
        badgeContent={isLoading || isPending ? undefined : (total ?? 0)}
        color="error"
        max={999}
        showZero={false}
        sx={{
          flexShrink: 0,
          '& .MuiBadge-badge': {
            fontSize: '0.65rem',
            fontWeight: 600,
            height: 18,
            minWidth: 18,
            padding: '0 5px',
            right: 2,
            top: 2,
          },
        }}
      >
        <Box sx={{ height: 18, width: 12 }} />
      </Badge>
    </Box>
  );
}
